var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 23.1175 1.9415 24 11 24C20.0585 24 22 23.1175 22 19C22 14.8825 20.0585 14 11 14C1.9415 14 0 14.8825 0 19Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 9.31371 7.68629 12 11 12C14.3137 12 17 9.31371 17 6C17 2.68629 14.3137 0 11 0C7.68629 0 5 2.68629 5 6Z",
    fill: "#9B9B9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/userDefault.f5b9c9bc3529e1c2dec5c89c78541fab.svg";
export { ForwardRef as ReactComponent };